<template>
    <base-section id="calculation" space="5">
        <v-container fluid>
            <v-card outlined>
                <v-tabs v-model="tab" background-color="secondary" centered dark icons-and-text dense>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1">
                        DASHBOARD MONITORING KLAIM <br>PT. GLOBAL OPTIMUS PRIME LOGISTIK
                        <v-icon>mdi-home</v-icon>
                    </v-tab>
                    <!-- <v-tab href="#tab-3">
                        PRODUKSI
                        <v-icon>mdi-cash-multiple</v-icon>
                    </v-tab>
                    <v-tab href="#tab-2">
                        SEARCH
                        <v-icon>mdi-magnify</v-icon>
                    </v-tab>
                    <v-tab href="#tab-4">
                        STOP LOSS
                        <v-icon>mdi-shield-alert-outline</v-icon>
                    </v-tab> -->
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                        <v-layout>
                            <v-row>
                                <!-- <v-col cols="12 mx-2 mt-5" md="2">
                                    <template>
                                        <v-card elevation="5" class="cursor" @click="GetData('pending')">
                                            <v-card-title class="body-2 font-weight-bold">Pending Review
                                                <v-spacer></v-spacer><span class="text-h3 font-weight-black"
                                                    v-text="pendingtotal.total"></span></v-card-title>
                                        </v-card>
                                    </template>
                                </v-col> -->
                                <v-col cols="12">
                                    <div></div>
                                    <v-progress-linear indeterminate color="primary"
                                        v-if="loading.detail"></v-progress-linear>
                                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                        hide-details class="mx-2"></v-text-field>
                                    <v-data-table :headers="headers" :items="items.claim" :search="search"
                                        @input="Check($event)" item-key="claim_row" class="elevation-1" :footer-props="{
                                            showFirstLastPage: true,
                                            firstIcon: 'mdi-page-first',
                                            lastIcon: 'mdi-page-last',
                                            prevIcon: 'mdi-chevron-left',
                                            nextIcon: 'mdi-chevron-right'
                                        }" dense :loading="loading.list" loading-text="Loading... Please wait">
                                            <template v-slot:item.claim_cdate="{ item }">
                                                {{ $functions.FormatDateIndo(item.claim_cdate) }}
                                            </template>
                                            <template v-slot:item.claim_sdate="{ item }">
                                                {{ $functions.FormatDateIndo(item.claim_sdate) }} s/d
                                                {{ $functions.FormatDateIndo(item.claim_edate) }}
                                            </template>
                                            <template v-slot:item.claim_tsi="{ item }">
                                                {{ $functions.FormatNumber(item.claim_tsi) }}
                                            </template>
                                            <template v-slot:item.claim_contribution="{ item }">
                                                {{ $functions.FormatNumber(item.claim_contribution) }}
                                            </template>
                                            <template v-slot:item.claim_sla="{ item }">
                                                {{ item.claim_sla }} Hari 
                                            </template>
                                            <template v-slot:item.action="{ item }">
                                                <v-btn icon @click="CheckTimeline(item)">
                                                    <v-icon>mdi-timeline-clock-outline</v-icon>
                                                </v-btn>
                                            </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-layout>
                        <v-dialog v-model="dialog.attachment" width="700" persistent>
                            <v-card>
                                <v-layout>
                                    <v-flex xs12 sm12>
                                        <v-card flat>
                                            <v-card-actions class="primary">
                                                <v-spacer></v-spacer>
                                                <v-btn color="fourth" outlined @click="dialog.attachment = false">
                                                    Batal
                                                </v-btn>
                                            </v-card-actions>
                                            <!-- <v-text-field class="mx-2" v-model="search.branchclient" placeholder="Cari Outlet dan Enter" id="filter_branchclient" append-icon="mdi-magnify" @keyup.enter="OpenData('outlet')"></v-text-field> -->
                                            <v-progress-linear indeterminate color="primary"
                                                v-if="loading.attachment"></v-progress-linear>
                                            <v-list two-line class="pt-0">
                                                <span v-if="items.attachment.length > 0">
                                                    <template v-for="(attachment, $index) in items.attachment">
                                                        <v-list-item :key="attachment.attachment_id"
                                                            :data-num="$index + 1" ripple>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ attachment.attachment_path
                                                                    }}</v-list-item-title>
                                                            </v-list-item-content>
                                                            <v-list-item-action>
                                                                <a :href="attachment.attachment_path_url"
                                                                    target="_blank" download>
                                                                    <v-icon
                                                                        color="#00b0e4">mdi-download-box-outline</v-icon>
                                                                </a>
                                                            </v-list-item-action>
                                                        </v-list-item>
                                                        <v-divider v-if="$index + 1 < items.attachment.length"
                                                            :key="$index"></v-divider>
                                                    </template>
                                                </span>
                                                <span v-else>
                                                    <v-list-item ripple>
                                                        <v-list-item-content>
                                                            <v-list-item-title>Tidak Ada Data</v-list-item-title>
                                                        </v-list-item-content>
                                                        <v-list-item-action>
                                                        </v-list-item-action>
                                                    </v-list-item>
                                                </span>
                                            </v-list>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialog.remarks" width="700" persistent>
                            <v-card>
                                <v-layout>
                                    <v-flex xs12 sm12>
                                        <v-card flat>
                                            <v-card-actions class="primary">
                                                <v-spacer></v-spacer>
                                                <v-btn color="fourth" outlined @click="dialog.remarks = false">
                                                    Batal
                                                </v-btn>
                                            </v-card-actions>
                                            <v-progress-linear indeterminate color="primary"
                                                v-if="loading.remarks"></v-progress-linear>
                                            <template>
                                                <v-form class="mx-2" ref="form" lazy-validation>
                                                    <v-text-field name="" v-model="form.claim_remarks" class="mt-4"
                                                        label="Remarks"></v-text-field>
                                                    <v-btn depressed small color="fourth" :disabled="sendremarks"
                                                        @click="dialog.confirm = true" class=" mb-2">Submit</v-btn>
                                                    <v-btn depressed small color="secondary"
                                                        @click="form.claim_remarks = ''" class="ml-2 mb-2">CLEAR
                                                        FORM</v-btn>
                                                </v-form>
                                                <v-card-text class="overflow-y-auto" :style="{ maxHeight: '355px' }"
                                                    v-html="claim_remarks_detail"></v-card-text>
                                            </template>
                                            <div></div>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialog.confirm" width="500" persistent>
                            <v-card>
                                <v-card-title class="body-1 grey lighten-2">
                                    Kirim?
                                </v-card-title>
                                <v-card-text class="body-2">
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="dialog.confirm = false">
                                        Batal
                                    </v-btn>

                                    <v-btn color="primary" text :disabled="dialog_ok === 'Ok' ? false : true"
                                        @click="Loading()">
                                        {{ dialog_ok }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialog.timeline" width="900" persistent>
                            <v-card>
                                <v-layout>
                                    <v-flex xs12 sm12>
                                        <v-card flat>
                                            <v-card-actions class="primary">
                                                <span style="color: white;">Timeline</span>
                                                <v-spacer></v-spacer>
                                                <v-btn color="fourth" outlined @click="dialog.timeline = false">
                                                    Batal
                                                </v-btn>
                                            </v-card-actions>

                                            <v-progress-linear indeterminate color="primary"
                                                v-if="loading.timeline"></v-progress-linear>
                                            <template>
                                                <div class="overflow-y-auto" :style="{ maxHeight: '600px' }">
                                                    <v-timeline class="mx-4" align-top
                                                        :dense="$vuetify.breakpoint.smAndDown">
                                                        <v-timeline-item v-for="(item, i) in items.attr" :key="i"
                                                            :color="item.color" :icon="item.icon" fill-dot>
                                                            <v-card :color="item.color" dark>
                                                                <v-card-title class="text-h6">
                                                                    {{ item.title }}
                                                                </v-card-title>
                                                                <v-list-item v-if="item.id == 'verify-claim'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{ items.timeline.claim_cuser
                                                                            }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                    $functions.FormatDateIndo(items.timeline.claim_cdate)
                }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'asign-surveyor'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_surveyassignby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_surveyassigndate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'claim-survey'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_surveyby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_surveydate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'assessor-estimate'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_estassesorby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_estassesordate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'claim-input'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_inputby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_inputdate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'claim-reserved'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_reserveby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_reservedate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'spk'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{ items.timeline.claim_spkby
                                                                            }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                    $functions.FormatDateIndo(items.timeline.claim_spkdate)
                }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'verify-document-send'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_verdocby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_verdocdate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'verify-document-accept'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_verdocappby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_verdocappdate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'publish-note'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_publishnoteby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_publishnotedate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'sign-note'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_signnoteby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_signnotedate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'disposition-note'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{
                    items.timeline.claim_dispositionby
                }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>
                                                                        {{
                        $functions.FormatDateIndo(items.timeline.claim_dispositiondate)
                    }}
                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                                <v-list-item v-if="item.id == 'verify-bju'"
                                                                    class="white text--primary">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title></v-list-item-title>
                                                                    </v-list-item-content>
                                                                    <v-list-item-action>

                                                                    </v-list-item-action>
                                                                </v-list-item>
                                                            </v-card>
                                                        </v-timeline-item>
                                                    </v-timeline>
                                                </div>
                                            </template>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-dialog>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-container>
        <!-- <v-bottom-sheet v-model="select.policy_vehicle_region">
            <v-list class="pt-0">
                <v-subheader class="primary white--text">Wilayah</v-subheader>
                <v-text-field v-model="filtersearch.policy_vehicle_region" class="mx-2"
                    prepend-inner-icon="mdi-magnify" />
                <div class="scrollable">
                    <v-list-item v-for="row in filter_wilayah" :key="row.carepolicy_data"
                        @click="Choose('region', row.carepolicy_data)">
                        <v-list-item-title class="text-center">{{ row.carepolicy_data }}</v-list-item-title>
                    </v-list-item>
                </div>
            </v-list>
        </v-bottom-sheet> -->
        <v-snackbar :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.dialog" rounded="pill" bottom>
            {{ snackbar.text }}
            <template>
                <v-btn text @click.native="snackbar.dialog = false">Close</v-btn>
            </template>
        </v-snackbar>
    </base-section>
</template>
<style>
/* Style for chat container */
.chat-container {
    max-width: 400px;
    /* Set the maximum width of the chat container */
    margin: 20px;
    /* Add some margin for spacing */
}

/* Style for each individual remark */
.header_remarks {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
}

/* Style for the "From" information */
.header_remarks b {
    color: #333;
}

/* Style for the date within each remark */
.remarks-date {
    align-self: flex-end;
    color: #999;
    font-size: 12px;
}

/* Style for alternating messages */
.header_remarks:nth-child(even) {
    align-self: flex-end;
    background-color: #e1ffc7;
    /* Light green background for even messages */
}

/* Optional: Style for horizontal rule (hr) */
hr {
    border: none;
    border-top: 1px solid #ccc;
    margin: 10px 0;
}
</style>
<script>
export default {
    name: 'GOPDashboard',
    data: () => ({
        form: {
            policy_inception: '',
            policy_expiry: '',
            policy_policyno: '',
            policy_certificateno: '',
            insured: '',
            policy_vehicle_region: '',
            policy_vehicle_type: '',
            policy_vehicle_license_no: '',
            claim_row: '',
            claim_remarks: ''
        },
        select: {
            policy_vehicle_region: false
        },
        loading: {
            detail: false,
            attachment: false,
            timeline: false,
            region: false,
            stoploss: false,
        },
        search: '',
        filtersearch: {
            policy_vehicle_region: ''
        },
        headerspending: [
            { text: 'No Polis', value: 'claim_polno' },
            { text: 'No Sertifikat', value: 'claim_certno' },
            { text: 'Tanggal Kehilangan', value: 'claim_dol' },
            { text: 'Tanggal Laporan', value: 'claim_cdate' },
            { text: 'No Kendaraan', value: 'claim_vehno' },
            { text: 'Lokasi Klaim', value: 'claim_location' },
            { text: '#', value: 'action', sortable: false, align: 'center' }
        ],
        headers: [
            // { text: 'No Sertifikat', value: 'claim_certificateno' },
            { text: 'Tanggal Lapor Klaim', value: 'claim_cdate' },
            { text: 'No Polis', value: 'claim_polno' },
            { text: 'Data Lengkap Kendaraan', value: 'claim_vehno' },
            { text: 'Periode', value: 'claim_sdate' },
            { text: 'TSI', value: 'claim_tsi', align: 'end' },
            { text: 'Kontribusi', value: 'claim_contribution', align: 'end' },
            { text: 'SLA Klaim', value: 'claim_sla' },
            { text: 'Status', value: 'claim_statusdesc' },
            { text: 'Tanggal Pembayaran', value: 'claim_paymentrefdate' },
            { text: 'Detail', value: 'action', sortable: false, align: 'center' }
        ],
        show: false,
        selected: [],
        items: {
            claim:[],
            policy: [],
            policybyregion: [],
            policystoploss: [],
            dashboard: [],
            attachment: [],
            timeline: [],
            attr: [],
            vehicle_region: [],
            vehicle_type: []
        },
        pendingtotal:
        {
            color: '#FF6600',
            total: 0,
            title: 'Pending Review',
        },
        format: {
            decimal: ',',
            thousands: '.',
            precision: 0
        },
        dialog: {
            attachment: false,
            remarks: false,
            confirm: false,
            timeline: false
        },
        dialog_ok: 'Ok',
        modal: {},
        //SnackBar
        snackbar: {
            dialog: false,
            color: 'success',
            text: '',
            timeout: 3000,
        },
        tab: null,
        login_user: '',
        url_type: '',
        sendremarks: false,
        claim_remarks_detail: '',
        confirm: {
            text: ""
        }
    }),
    watch: {
        'form.policy_inception': function (val) {
            // Validate if both dates are selected before updating the other date
            if (val && this.form.policy_expiry && new Date(val) > new Date(this.form.policy_expiry)) {
                this.form.policy_expiry = val;
            }
        },
        'form.policy_expiry': function (val) {
            // Validate if both dates are selected before updating the other date
            if (val && this.form.policy_inception && new Date(val) < new Date(this.form.policy_inception)) {
                this.form.policy_inception = val;
            }
        }
    },
    provide: {
        heading: { align: 'center' },
    },
    created() {
        this.GetData()
        // this.GetData('vehicle_region')
        // this.GetData('stoploss')
    },
    computed: {
        filter_wilayah() {
            const search_wilayah = this.filtersearch.policy_vehicle_region.toLowerCase().trim()
            if (!search_wilayah) {
                return this.items.vehicle_region
            } else {
                return this.items.vehicle_region.filter(b => b.carepolicy_data.toLowerCase().indexOf(search_wilayah) > -1)
            }
        },
    },
    methods: {
        SelectAllPage() {
            this.selected = this.selected === this.items ? [] : this.items
        },
        Check(value) {
            this.selected = value
        },
        CheckData() {
            this.loading.detail = true
            let formData = new FormData()
            formData.append('policy_insuredname', this.form.insured)
            formData.append('policy_inception', this.form.policy_inception)
            formData.append('policy_expiry', this.form.policy_expiry)
            formData.append('policy_policyno', this.form.policy_policyno)
            formData.append('policy_vehicle_region', this.form.policy_vehicle_region)
            formData.append('policy_vehicle_type', this.form.policy_vehicle_type)
            formData.append('policy_vehicle_license_no', this.form.policy_vehicle_license_no)
            formData.append('policy_certificateno', this.form.policy_certificateno)
            this.$axios.post(this.$functions.SafeURL('apiListClaimGOP', ``), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.items.policy = feedback
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 0)
                        }
                    } else {
                        this.items.policy = feedback
                    }
                    this.loading.detail = false
                })
                .catch(e => {
                    this.loading.detail = false
                    this.SnackBar(true, 'error', e.message, 3000)
                })
        },
        ClearForm() {
            this.form.policy_inception = ""
            this.form.policy_expiry = ""
            this.form.policy_policyno = ""
            this.form.policy_certificateno = ""
            this.form.insured = ""
            this.form.policy_vehicle_region = ""
            this.form.policy_vehicle_type = ""
            this.form.policy_vehicle_license_no = ""
        },
        GetAttachment(refno) {
            this.dialog.attachment = true
            this.loading.attachment = true
            let formData = new FormData()
            formData.append('attachment_refno', refno)
            formData.append('attachment_modul', 'claimreg')
            this.$axios.post(this.$functions.SafeURL('apiListAttachment', ``), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.items.attachment = feedback
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 0)
                        }
                    } else {
                        this.items.attachment = feedback
                    }
                    this.loading.attachment = false
                })
                .catch(e => {
                    this.loading.detail = false
                    this.SnackBar(true, 'error', e.message, 3000)
                })
        },
        CheckTimeline(item) {
            this.items.timeline = item
            this.items.attr = [
                {
                    title: 'Report and Verification Claim',
                    color: item.claim_cuser !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_cuser !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'verify-claim'
                },
                {
                    title: 'Assign Surveyor',
                    color: item.claim_surveyassignby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_surveyassignby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'asign-surveyor'
                },
                {
                    title: 'Claim Survey',
                    color: item.claim_surveyby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_surveyby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'claim-survey'
                },
                {
                    title: 'Assessor Estimate',
                    color: item.claim_estassesorby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_estassesorby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'assessor-estimate'
                },
                {
                    title: 'Claim Input',
                    color: item.claim_inputby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_inputby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'claim-input'
                },
                {
                    title: 'Claim Reserved',
                    color: item.claim_reserveby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_reserveby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'claim-reserved'
                },
                {
                    title: 'SPK',
                    color: item.claim_spkby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_spkby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'spk'
                },
                {
                    title: 'Verification Document (Send)',
                    color: item.claim_verdocby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_verdocby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'verify-document-send'
                },
                {
                    title: 'Verification Document (Accept)',
                    color: item.claim_verdocappby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_verdocappby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'verify-document-accept'
                },
                {
                    title: 'Publish Note',
                    color: item.claim_publishnoteby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_publishnoteby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'publish-note'
                },
                {
                    title: 'Sign Note',
                    color: item.claim_signnoteby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_signnoteby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'sign-note'
                },
                {
                    title: 'Disposition Note',
                    color: item.claim_dispositionby !== '' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_dispositionby !== '' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'disposition-note'
                },
                {
                    title: 'Verification BJU',
                    color: item.claim_status == 'U' ? 'green darken-2' : 'red darken-2',
                    icon: item.claim_status == 'U' ? 'mdi-check-decagram' : 'mdi-progress-close',
                    id: 'verify-bju'
                },
            ];
            this.dialog.timeline = true
        },
        SetRemarks(flag, id, remarks) {
            if (flag === 'updateremark') {
                this.url_type = 'updateremark'
                this.dialog.remarks = true
                this.form.claim_row = id
                this.claim_remarks_detail = remarks
            }
        },
        Loading() {
            this.dialog_ok = 'Loading...'
            if (this.url_type === 'updateremark') {
                // this.UpdateRemarks(this.form.claim_row)
            }
        },
        SnackBar(dialog, color, text, timeout) {
            this.snackbar.dialog = dialog
            this.snackbar.color = color
            this.snackbar.text = text
            this.snackbar.timeout = timeout
        },
        GetData() {
            let loginid = localStorage.getItem('website_users_id')
            if (loginid === null) {
                window.location.href = '/login'
            } else {
                this.loading.detail = true
                this.filtersearch.policy_vehicle_region = ''
                let formdata = new FormData()
                // formdata.append('url_type', 'region')
                this.$axios.post(this.$functions.SafeURL('apiListClaimGOP'), formdata, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    this.select.policy_vehicle_region = true
                    this.items.claim = response.data
                    this.loading.detail = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e.message, 3000)
                    this.loading.detail = false
                })
            }
        },
        Choose(flag, desc) {
            switch (flag) {
                case 'region':
                    this.form.policy_vehicle_region = desc
                    this.select.policy_vehicle_region = false
                    break;
            }
        },
     
        getClaimRatio(gross, claim) {
            const ratio = (claim / gross) * 100;
            var value = parseFloat(ratio).toFixed(2);
            return Math.abs(value);
        },
    },
}
</script>